import '../app.es6';
import angular from 'angular';

class Authentication {
  /* @ngInject */
  constructor ($route, $location, $cookies, $sessionStorage, Resource, LoginType, GA) {
    Object.assign(this, {
      $route,
      $location,
      $cookies,
      $sessionStorage,
      Resource,
      LoginType,
      GA
    });

    Authentication.$inject = ['$route', '$location', '$cookies', '$sessionStorage', 'Resource', 'LoginType', 'GA'];
  }

  execute () {
    let loginPath = `/${this.LoginType.getShorthand()}/login`;
    if (this.$cookies.get('session_exists')) {
      let user = this.$sessionStorage.user;
      if (user) {
        // $sessionStorage.userの内容は信用できないが、不正な時はリダイレクトが走るためその時まではサインイン済みだと信じる
        // サインイン済みなら、GAのユーザー関連のカスタムディメンションを設定する
        this.GA.setUserCustomDimensions(user);
      } else {
        // $sessionStorage.userが設定されていない場合は設定してリロード
        // 失敗した場合はrestangularの方でリダイレクトされる設定になっている
        let request = this.Resource.new().user();
        request.get().then((user) => {
          this.$sessionStorage.user = user;
          this.$route.reload();
        });
      }
    } else {
      // session_idがcookieにない場合、初期ユーザーとみなす
      if (!this.$location.path().match(/\/login$/)) {
        this.$location.path(loginPath);
      }
    }
  }
}

angular.module('myApp').service('Authentication', Authentication);



// WEBPACK FOOTER //
// ./app/services/authentication.es6